module.exports = SharedDependencies.FormState['application'];